import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-blog-ibs-introduces-cablefinder-tool-page',
  templateUrl: './blog-ibs-introduces-cablefinder-tool-page.component.html',
  styleUrls: ['./blog-ibs-introduces-cablefinder-tool-page.component.css']
})
export class BlogIbsIntroducesCablefinderToolPageComponent implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit(): void {
    this.titleService.setTitle("Innovative Business Solutions Introduces Ground-Breaking Cable Serviceability Tool, CableFinder.net");
  }

}
